import { combineReducers } from 'redux';
import {CardGiftcard as TrialVoucherIcon,
} from '@material-ui/icons';

// Reducers
import billingAccountReducer from './BillingAccount/store/billingAccountReducer';
import billingPlanReducer from './BillingPlan/store/billingPlanReducer';

export const subComponents = translations => [
    { name: translations['account'] || 'Accounts', path: '/accounts', permissions: ['access_all_billing_accounts'] },
    { name: translations['plan'] || 'Plans', path: '/plans', permissions: ['billing_account_plan_list'] },
    { name: translations["license_prototype"] || "License prototype", permissions: ["license_prototype"], path: "/license-prototype",},
    { name: translations['trial_vouchers'] || 'Trial Vouchers', icon: TrialVoucherIcon, permissions: ["trial_voucher_list"], path: "/trial-vouchers",},
    { name: translations["delivery_notes"] || "Delivery notes", path: "/deliveryNotes", permissions: ["delivery_note_list"] },
];

export const reducers = combineReducers({
    accounts: billingAccountReducer,
    plans: billingPlanReducer
});
